export default function InputName() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            model: "=",
            validation: "=",
            label: "=",
        },
        template: require("./template.html"),

        // link: function(scope, element, attrs) {},
        controller: function ($scope, $timeout) {
            $timeout(() => {
                // wait for the form to be ready
                $scope.form.name.customErrorMessages = [
                    {
                        field: "name",
                        type: "required",
                        message: "Navn er påkrævet",
                        label: $scope.label,
                    },
                ];
            });
        },
    };
}
